import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TableRow, Modal, TablePagination, Paper, IconButton, InputBase } from "@material-ui/core";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { GROCERY_ITEM } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import { Box, Button, Chip, useMediaQuery, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import EditPenIcon from "src/svgComponents/EditPenIcon";
import CloseIcon from '@mui/icons-material/Close';
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useTheme } from '@mui/material/styles';
import { useMutation } from "react-query";
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import useStore from 'src/contexts/AuthProvider';
import AppTooltip from "src/components/common/AppTooltip";
import { LoadingButton } from '@mui/lab';
import ButtonText from "src/components/common/ButtonText";

const _ = require('lodash');

const GroceryMenu = () => {
   const [tableData, setTableData] = useState([]);
   const [page, setPage] = useState(0);
   const [filterName, setFilterName] = useState('');
   const [rowsPerPage, setRowsPerPage] = useState(5);
   const [order, setOrder] = useState('desc');
   const [orderBy, setOrderBy] = useState('createdAt');
   const axiosPrivate = useAxiosPrivate();
   const [loading, setLoding] = useState(true);
   const [openModal, setOpenModal] = useState(false);
   const [modelTitle, setmodelTitle] = useState("");
   const [parentId, setParentId] = useState('');
   const [disable, setDisable] = useState(false);
   const [Id, setId] = useState("");
   const { enqueueSnackbar } = useSnackbar();
   const [deleteId, setdeleteId] = useState("");
   const [open, setOpen] = useState(false);
   const [buttonLoading, setButtonLoding] = useState(false);
   const theme = useTheme();
   const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
   const permissionsData = useStore(state => state.permissions);

   const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
         backgroundColor: '#ffffff',
      },
      '&:nth-of-type(even)': {
         background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
      },
      // hide last border
      '& td, & th': {
         border: 0,
      },
   }));

   const TABLE_HEAD = [
      { id: 'name', label: 'Menu Name', alignRight: false },
      { id: 'status', label: 'Status', alignRight: false },
      { id: 'action', label: 'Action', alignRight: false },
   ];

   async function getGrocerymenu() {
      const response = await axiosPrivate.get(GROCERY_ITEM.getGrocerymenu, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
      return response.data[0];
   }

   const { data: groceryMenu, refetch } = useQuery(['groceryMenu', page, filterName], () => getGrocerymenu(), { keepPreviousData: true, })

   useEffect(() => {
      if (groceryMenu) {
         setTableData(groceryMenu.data);
         setRowsPerPage(10);
      }
      setTimeout(() => {
         setLoding(false);
      }, 1000)
   }, [groceryMenu])

   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      setTimeout(() => {
         refetch();
      }, 500);
   };

   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };

   const handleFilterByName = (event) => {
      setFilterName(event.target.value.trim());
      setPage(0);
      getGrocerymenu(page, filterName)
      refetch();
   };

   const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
   };

   const completedSchema = Yup.object().shape({
      name: Yup.string()
         .min(2, "Menu name can set of between 2 and 50 characters!")
         .max(50, "Menu name can set of between 2 and 50 characters!")
         .required("Menu name is required")
   });

   const formik = useFormik({
      initialValues: {
         name: ""
      },
      validationSchema: completedSchema,
      onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
         const informationObj = {
            name: values.name.trim(),
         };
         setButtonLoding(true);
         if (Id === "") {
            await groceryAdd(informationObj);
         } else {
            await foodMenuUpdate(informationObj);
         }
         setParentId("");
         resetForm();
         setSubmitting(false);
      },
   });

   const { mutateAsync: groceryAdd } = useMutation(
      async (data) => {
         return await axiosPrivate.post(GROCERY_ITEM.addGroceryMenu, data)
      },
      {
         onSuccess: ({ data }) => {
            enqueueSnackbar("Add successfully ", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            handleCloseModal();
            refetch();
            setButtonLoding(false);
         },
         onError: (error) => {
            setButtonLoding(false);
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }
            Object.keys(errorData).forEach((key) => {
               if (key === "name") {
                  setFieldError("name", errorData[key]);
               } else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );

   const { mutateAsync: foodMenuUpdate } = useMutation(
      async (data) => {
         return await axiosPrivate.put(GROCERY_ITEM.editGroceryMenu + Id, data)
      },
      {
         onSuccess: ({ data }) => {
            refetch();
            enqueueSnackbar("Update successfully ", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            handleCloseModal();
            setButtonLoding(false);
         },
         onError: (error) => {
            setButtonLoding(false);
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }
            Object.keys(errorData).forEach((key) => {
               if (key === "name") {
                  setFieldError("name", errorData[key]);
               } else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );

   function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
         return -1;
      }
      if (b[orderBy] > a[orderBy]) {
         return 1;
      }
      return 0;
   }

   function getComparator(order, orderBy) {
      return order === 'desc'
         ? (a, b) => descendingComparator(a, b, orderBy)
         : (a, b) => -descendingComparator(a, b, orderBy);
   }

   function applySortFilter(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
         const order = comparator(a[0], b[0]);
         if (order !== 0) return order;
         return a[1] - b[1];
      });

      return stabilizedThis.map((el) => el[0]);
   }

   const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

   const handleClose = () => {
      setOpen(false);
   };

   const deleteFoodMenu = async () => {
      const response = await axiosPrivate.delete(GROCERY_ITEM.deleteGroceryMenu + deleteId)
      if (response.status === 200) {
         enqueueSnackbar("Menu deleted successfully", {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      } else {
         enqueueSnackbar("something went wrong", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch();
      handleClose();
   };

   const handleOpenModalAdd = () => {
      setFieldValue('name', "")
      setId('')
      setmodelTitle('Create Your Grocery Menu')
      setDisable(false);
      setOpenModal(true);
   };

   const handleOpenModalUpdate = (row) => {
      setFieldValue('name', row.name)
      setId(row._id)
      setmodelTitle('Edit Your Grocery Menu')
      setDisable(true);
      setOpenModal(true);
   };

   const handleClickOpen = (categoryId, categoryType) => {
      setdeleteId(categoryId);
      setOpen(true);
   };

   const handleCloseModal = () => {
      setOpenModal(false);
      resetForm();
   };

   const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps, resetForm } = formik;

   const changeStatus = async (id) => {
      const response = await axiosPrivate.put(GROCERY_ITEM.changeStatus + id)
      if (response?.data?.message) {
         enqueueSnackbar(response?.data?.message, {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch()
   }

   return (
      <>
         <LoadingScreen loading={loading} />
         <div className="dashboard_header mb-4">
            <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Grocery Menu</h4>
            <Box className="d-flex align-items-center">
               <Paper component="form" className='dashboard_searchbox' sx={{ minWidth: '380px' }}>
                  <IconButton>
                     <SearchIcon />
                  </IconButton>
                  <InputBase
                     fullWidth
                     sx={{ flex: 1 }}
                     placeholder="Search Grocery Menu..."
                     onChange={(e) => handleFilterByName(e)}
                     onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                  />
               </Paper>
               <Stack direction={"row"} className="d-flex align-items-center ms-lg-4 ms-2" spacing={2}>
                  {permissionsData?.grocery_menu?.substring(1, 2) === "1" ?
                     <AppTooltip title="Add Menu" placement="bottom">
                        <ButtonText text={'Create Menu'} onClickBtn={() => handleOpenModalAdd()} />
                     </AppTooltip> : ""}
               </Stack>
            </Box>
         </div>
         <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
         >
            <DialogTitle id="responsive-dialog-title" className='m-auto'>
               {"Are you sure you want to delete?"}
            </DialogTitle>
            <DialogContent>
               {"If you delete this grocerymenu you also deleted related grocery items!!!"}
            </DialogContent>
            <DialogActions className='m-auto'>
               <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                  cancel
               </Button>
               <Button className="theme_button" variant="contained" onClick={() => deleteFoodMenu()} autoFocus>
                  delete
               </Button>
            </DialogActions>
         </Dialog>
         <Card>
            <TableContainer>
               <Table>
                  <UserListHead
                     headLabel={TABLE_HEAD}
                     rowCount={groceryMenu?.data?.length}
                     onRequestSort={handleRequestSort}
                  />
                  {filteredUsers.length > 0 ?
                     <TableBody>
                        {filteredUsers.map((row) => {
                           return (
                              <StyledTableRow key={row._id}>
                                 <TableCell component="th" scope="row">
                                    {row.name}
                                 </TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       {
                                          row.status === 1 ? <Chip variant="contained" label="Enable" className="app_status_chip accepted" onClick={() => changeStatus(row._id)} /> : <Chip variant="contained" className="app_status_chip invalid" label="Disable" onClick={() => changeStatus(row._id)} />
                                       }
                                    </Stack>
                                 </TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       {permissionsData?.grocery_menu?.substring(3, 4) == "1" ?
                                          <AppTooltip title="Edit" placement="bottom">
                                             <Button sx={{ "&:hover": { bgcolor: "transparent" } }} onClick={() => handleOpenModalUpdate(row)} variant="text" className="user_list_row_btn" ><EditPenIcon /></Button>
                                          </AppTooltip> : ""}
                                       {/* {permissionsData?.grocery_menu?.substring(2, 3) == "1" ?
                                             <AppTooltip title="Delete" placement="bottom">
                                                <Button variant="text" className="user_list_row_btn" onClick={() => handleClickOpen(row._id, "main")} ><BinIcon /></Button>
                                             </AppTooltip> : ""} */}
                                    </Stack>
                                 </TableCell>
                              </StyledTableRow>
                           )
                        })}
                        {/* {emptyRows > 0 && (
                           <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                           </TableRow>
                        )} */}
                     </TableBody>
                     :
                     <TableBody>
                        <TableRow>
                           <TableCell align="center" colSpan={4} sx={{ py: 5 }}>
                              <span className="app_text_16_semibold">no data found</span>
                           </TableCell>
                        </TableRow>
                     </TableBody>}
               </Table>
            </TableContainer>
            <TablePagination
               component="div"
               rowsPerPageOptions={[10, 20, 50, 100]}
               count={groceryMenu?.metadata.length !== 0 ? groceryMenu?.metadata[0].total : 0}
               rowsPerPage={rowsPerPage}
               page={page}
               onPageChange={handleChangePage}
               onRowsPerPageChange={handleChangeRowsPerPage}
            />
         </Card>
         <Dialog
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
         >
            <DialogTitle>
               <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <h4>{modelTitle}</h4>
                  <Button className="dashboard_light_bg_icon_btn" onClick={handleCloseModal} aria-label="delete">
                     <CloseIcon style={{ color: '#fff' }} />
                  </Button>
               </Box>
            </DialogTitle>
            <DialogContent className="custom_form_mui pt-2" sx={{ minWidth: '400px' }}>
               <FormikProvider value={formik}>
                  <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                     <div className="row">
                        <div className="col-12">
                           <div className="form-group mb-4">
                              <p className="label-text">You can create your own grocery menu options like Meat, Sugar, Oils etc.</p>
                              <TextField name='name' label="Menu Name" variant="outlined" fullWidth
                                 {...getFieldProps('name')}
                                 error={Boolean(touched.name && errors.name)}
                                 helperText={touched.name && errors.name}
                              />
                           </div>
                        </div>
                     </div>
                     <div className="col">
                        <div className="col-md-8 m-auto">
                           <LoadingButton
                              type='submit'
                              fullWidth
                              className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                              loading={buttonLoading}
                              loadingPosition="end"
                              variant="contained"
                           >
                              submit
                           </LoadingButton>
                        </div>
                     </div>
                  </Form>
               </FormikProvider>
            </DialogContent>
         </Dialog>
      </>
   )
}

export default GroceryMenu